import React, { useEffect } from 'react'
import qs from 'qs'
import I18n from 'i18n'
import Button from '../../atomic/atoms/Button'
import Spinner from '../../common/Spinner'
import { WithSession } from '../../session/SessionProvider'

const Authorization = (props) => {
  if (props.session.redirectToLoginIfNoSession()) return <></>

  const {
    client_id: clientId,
    redirect_uri: redirectUri,
    code_challenge: codeChallenge,
    code_challenge_method: codeChallengeMethod,
    state
  } = qs.parse(props.location.search, { ignoreQueryPrefix: true })

  useEffect(() => {
    props.fetchApplicationDetails(clientId)
  }, [])

  const isReadOnly = () => {
    const scopes = props.applicationData?.scopes
    return scopes && scopes.length === 1 && scopes[0] === 'read'
  }

  useEffect(() => {
    // Automatically authorize read-only scope
    if (isReadOnly()) {
      props.authorizeApplication(props.applicationData, redirectUri, codeChallenge, codeChallengeMethod, state)
    }
  }, [props.applicationData])

  const scopes = () => {
    const renderedScopes = props.applicationData.scopes.map((scope) => {
      return (
        <div key={scope} className='no-margin collection-item'>
          <span className='badge text-muted'>{I18n.t(`oauth.scope.short.${scope}`)}</span>
          <span>{I18n.t(`oauth.scope.description.${scope}`)}</span>
        </div>
      )
    })
    return (
      <div className='collection'>{renderedScopes} </div>
    )
  }
  // Extract the code from the redirect url to be displayed in UI
  const oauthCode = props?.authorizedResult?.redirect_uri?.code

  const handleSubmit = (e) => {
    e.preventDefault()
    props.authorizeApplication(props.applicationData, redirectUri, codeChallenge, codeChallengeMethod, state)
  }

  if (!props.applicationData) return <></>

  if (isReadOnly()) {
    return (
      <div className='center-align oauth-loading-overlay'>
        <Spinner transparent />
        <p>{I18n.t('oauth.auto_authorize_read_only', { name: props.applicationData.name })}</p>
      </div>
    )
  }

  return (
    <div className='container'>
      <div className='row'>
        <div className='col s12'>
          <div className='text-heavy text-primary-color text-l'>
            {I18n.t('oauth.title')}
          </div>
          <p>{I18n.t('oauth.application_description', { name: props.applicationData.name })}</p><br />
          <div className='row'>
            <div className='col s12' />
          </div>
          <ul>{scopes()}</ul>
        </div>
      </div>
      <div className='row'>
        <form>
          <div className='col s12'>
            <Button
              onClick={handleSubmit}
              autowidth
              cy='submit'
            >{I18n.t('oauth.authorize')}
            </Button>
          </div>
        </form>
      </div>
      {props.authorizedResult &&
        <div className='row'>
          <div className='col s12'>
            <p>Code: {oauthCode}</p>
          </div>
        </div>}
    </div>
  )
}
export default WithSession(Authorization)
